import React from 'react';
import { getUserData } from '~/store/user/selectors';
import { useSelector } from 'react-redux';
import { Viewer } from '@grapecity/activereports-react';
import '@grapecity/activereports/styles/ar-js-ui.css';
import '@grapecity/activereports/styles/ar-js-viewer.css';
import report from './summary-pdf.json';
import { Core } from '@grapecity/activereports';
import { ActiveReportJSKey } from '~/features/dashboard';

export const DashboardPreview = () => {
    const userData: any = useSelector(getUserData);
    const reportUri: any = JSON.parse(
        JSON.stringify(report)
            .replaceAll('[API]', String(process.env.REACT_APP_API))
            .replaceAll('[TOKEN]', userData.data?.token)
    );

    Core.setLicenseKey(ActiveReportJSKey);

    return (
        <div style={{ height: '100%', width: '100%' }}>
            <Viewer report={{ Uri: reportUri }} />
        </div>
    );
};
